import { Form, FormControlProps, InputGroup, Input } from "rsuite";
import { forwardRef, useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../core/redux/reduxStore";
import { ActionUI } from "../../../core/redux/slices/sliceUI";

type WithIconTextAreaFormInputProps = {
  showError?: boolean;
  errorText?: string;
  type?: string | undefined;
  onBlurFunc?: () => void;
  onFocusFunc?: () => void;
  svgicon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
} & FormControlProps;

const Textarea = forwardRef<HTMLTextAreaElement>((props, ref) => (
  <Input {...props} size="md" />
));

export const WithIconTextAreaFormInputForResetPassword = ({
  type,
  name,
  className,
  ...props
}: WithIconTextAreaFormInputProps) => {
  const { onBlurFunc, onFocusFunc } = props;
  const [errorVisible, setErrorVisible] = useState(props.showError);
  const { userFormError } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();
  const errorStyles = (errorVisible: any, error: any) => {
    return {
      display: error || errorVisible ? "block" : "none",
      color: "red",
      marginTop: 6,
    };
  };

  useEffect(() => {
    setErrorVisible(props.showError);
  }, [props]);

  return (
    <>
      <Form.Group as={InputGroup} className={`m-0 p-0 w-100` + className}>
        <Form.ControlLabel as={InputGroup.Addon} className="m-0">
          {props.svgicon && <props.svgicon />}
        </Form.ControlLabel>
        <Form.Control
          accepter={Textarea}
          id={name}
          className="textarea-form-input"
          name={name}
          type={type ? type : `text`}
          onBlur={(e: any) => {
            onBlurFunc ? onBlurFunc() : <></>;
            if (e.target.value === "" || props.showError) {
              setErrorVisible(true);
            }
          }}
          onFocus={() => {
            onFocusFunc ? onFocusFunc() : <></>;
            setErrorVisible(false);
            dispatch(
              ActionUI.setUserFormError({ ...userFormError, [name]: false })
            );
          }}
          {...props}
        />
        {/* {props.showError && props.errorText ? (
        <Form.ErrorMessage show={errorVisible || (userFormError as any)[name]} placement={"bottomStart"} style={{ left: "25px" }}>
          {props.errorText}
        </Form.ErrorMessage>
      ) : (
        <></>
      )} */}
      </Form.Group>
      {props.showError && props.errorText ? (
        <div style={errorStyles(errorVisible, (userFormError as any)[name])}>
          {props.errorText}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
